export const MenuProps = {
  PaperProps: {
    style: {
      height: 300
    }
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  getContentAnchorEl: null,
  disableScrollLock: true
};

export const MenuPropsForTableFilter = {
  // anchorOrigin: {
  //   vertical: "bottom",
  //   horizontal: "left"
  // },
  // transformOrigin: {
  //   vertical: "top",
  //   horizontal: "left"
  // },
  getContentAnchorEl: null,
  disableScrollLock: true
};
